"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconUserEdit = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconUserEdit = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0428 10.0429C19.1237 8.96201 20.8761 8.962 21.957 10.0429C23.0379 11.1237 23.0379 12.8763 21.957 13.9572C19.7972 16.117 17.6337 18.2732 15.4775 20.4366C15.3924 20.5221 15.2851 20.6297 15.1596 20.7219C15.0505 20.802 14.9335 20.8708 14.8105 20.9272C14.669 20.9922 14.5228 21.0337 14.4068 21.0667C13.3622 21.3632 12.3187 21.6632 11.2746 21.9615C10.9254 22.0613 10.5496 21.9639 10.2928 21.7071C10.036 21.4503 9.93858 21.0745 10.0384 20.7253C10.3367 19.6812 10.6367 18.6377 10.9332 17.5931C10.9662 17.4771 11.0077 17.3309 11.0726 17.1894C11.1291 17.0664 11.1979 16.9494 11.278 16.8403C11.3702 16.7148 11.4778 16.6075 11.5633 16.5224C13.7267 14.3662 15.883 12.2027 18.0428 10.0429Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60976 14.5101C6.75498 14.522 6.96297 14.5524 7.18091 14.6635C7.46316 14.8073 7.69263 15.0368 7.83644 15.319C7.94749 15.537 7.97793 15.745 7.9898 15.8902C8.00003 16.0155 7.99998 16.1578 7.99993 16.2769C7.99945 17.5923 7.99945 18.9077 7.99993 20.2231C7.99998 20.3423 8.00003 20.4845 7.9898 20.6098C7.97793 20.7551 7.94749 20.963 7.83644 21.181C7.69263 21.4632 7.46316 21.6927 7.18091 21.8365C6.96297 21.9476 6.75498 21.978 6.60976 21.9899C6.48444 22.0001 6.34218 22.0001 6.22307 22C3.34568 21.999 5.46779 21.9847 2.59044 22.0001C2.51908 22.0005 2.37563 22.0012 2.23946 21.9772C1.61844 21.8677 1.13222 21.3815 1.02272 20.7605C0.998707 20.6243 0.999471 20.4809 0.999851 20.4095C1.003 19.8186 0.972816 19.2163 1.07589 18.6318C1.4409 16.5617 3.06163 14.941 5.13168 14.576C5.77853 14.4619 6.34171 14.4882 6.60976 14.5101Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49993 7.5C4.49993 4.46243 6.96236 2 9.99993 2C13.0375 2 15.4999 4.46243 15.4999 7.5C15.4999 10.5376 13.0375 13 9.99993 13C6.96236 13 4.49993 10.5376 4.49993 7.5Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5ZM11 21L14.1014 20.1139C14.2499 20.0715 14.3241 20.0502 14.3934 20.0184C14.4549 19.9902 14.5134 19.9558 14.5679 19.9158C14.6293 19.8707 14.6839 19.8161 14.7932 19.7068L21.25 13.25C21.9404 12.5597 21.9404 11.4403 21.25 10.75C20.5597 10.0596 19.4404 10.0596 18.75 10.75L12.2932 17.2068C12.1839 17.3161 12.1293 17.3707 12.0842 17.4321C12.0442 17.4866 12.0098 17.5451 11.9816 17.6066C11.9497 17.6759 11.9285 17.7501 11.8861 17.8987L11 21Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconUserEdit = IconUserEdit;
//# sourceMappingURL=IconUserEdit.js.map